/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkspaceAccessLevel } from './WorkspaceAccessLevel';
import {
    WorkspaceAccessLevelFromJSON,
    WorkspaceAccessLevelFromJSONTyped,
    WorkspaceAccessLevelToJSON,
} from './WorkspaceAccessLevel';

/**
 * 
 * @export
 * @interface VwbWorkspace
 */
export interface VwbWorkspace {
    /**
     * ID of the workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    id?: string;
    /**
     * ID of the workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    googleProjectId?: string;
    /**
     * ID of the workspace displayed to the user
     * @type {string}
     * @memberof VwbWorkspace
     */
    userFacingId?: string;
    /**
     * ID of the billing account for the workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    billingAccountId?: string;
    /**
     * The name of the workspace as displayed in the UI.
     * @type {string}
     * @memberof VwbWorkspace
     */
    displayName: string;
    /**
     * The description of the workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    description?: string;
    /**
     * JSON string containing all research purpose description data
     * @type {string}
     * @memberof VwbWorkspace
     */
    researchPurpose?: string;
    /**
     * Username of the workspace creator
     * @type {string}
     * @memberof VwbWorkspace
     */
    createdBy?: string;
    /**
     * Timestamp the workspace was created
     * @type {string}
     * @memberof VwbWorkspace
     */
    creationTime?: string;
    /**
     * The data collection associated with the workspace CT/RT
     * @type {string}
     * @memberof VwbWorkspace
     */
    dataCollection?: string;
    /**
     * 
     * @type {WorkspaceAccessLevel}
     * @memberof VwbWorkspace
     */
    role?: WorkspaceAccessLevel;
    /**
     * The timestamp of the last change to the workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    lastChanged?: string;
    /**
     * The user-facing ID of the VWB billing pod attached to this workspace
     * @type {string}
     * @memberof VwbWorkspace
     */
    podUserFacingId?: string;
}

/**
 * Check if a given object implements the VwbWorkspace interface.
 */
export function instanceOfVwbWorkspace(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;

    return isInstance;
}

export function VwbWorkspaceFromJSON(json: any): VwbWorkspace {
    return VwbWorkspaceFromJSONTyped(json, false);
}

export function VwbWorkspaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbWorkspace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'googleProjectId': !exists(json, 'googleProjectId') ? undefined : json['googleProjectId'],
        'userFacingId': !exists(json, 'userFacingId') ? undefined : json['userFacingId'],
        'billingAccountId': !exists(json, 'billingAccountId') ? undefined : json['billingAccountId'],
        'displayName': json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'researchPurpose': !exists(json, 'researchPurpose') ? undefined : json['researchPurpose'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'dataCollection': !exists(json, 'dataCollection') ? undefined : json['dataCollection'],
        'role': !exists(json, 'role') ? undefined : WorkspaceAccessLevelFromJSON(json['role']),
        'lastChanged': !exists(json, 'lastChanged') ? undefined : json['lastChanged'],
        'podUserFacingId': !exists(json, 'podUserFacingId') ? undefined : json['podUserFacingId'],
    };
}

export function VwbWorkspaceToJSON(value?: VwbWorkspace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'googleProjectId': value.googleProjectId,
        'userFacingId': value.userFacingId,
        'billingAccountId': value.billingAccountId,
        'displayName': value.displayName,
        'description': value.description,
        'researchPurpose': value.researchPurpose,
        'createdBy': value.createdBy,
        'creationTime': value.creationTime,
        'dataCollection': value.dataCollection,
        'role': WorkspaceAccessLevelToJSON(value.role),
        'lastChanged': value.lastChanged,
        'podUserFacingId': value.podUserFacingId,
    };
}

